import { useEffect } from 'react';

interface HeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
}

export default function Head({
  title = '黑料吃瓜网官网入口 | 吃瓜网 - 今日热点黑料、网红大瓜实时更新',
  description = '⭐黑料吃瓜网官网入口，每日更新全网最新热点黑料、网红大瓜与明星八卦，免费吃瓜资源24小时不打烊',
  keywords = '黑料吃瓜网,吃瓜网,今日热点黑料,网红大瓜,免费吃瓜,明星八卦',
  canonicalUrl = '/',
  ogTitle = '黑料吃瓜网官网入口 | 吃瓜网 - 今日热点黑料、网红大瓜实时更新',
  ogDescription = '全网最新热点黑料、网红大瓜与明星八卦，免费吃瓜资源24小时不打烊',
  ogType = 'website',
}: HeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);
    setMeta('og:title', ogTitle, true);
    setMeta('og:description', ogDescription, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('twitter:title', ogTitle);
    setMeta('twitter:description', ogDescription);
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType]);

  return null;
}